import type { CurrencyCode } from '@/shared/lib/currency';

export enum JettonStatus {
  WAITING = 'waiting',
  COUNTDOWN = 'countdown',
  FLYING = 'flying',
  CRASHED = 'crashed',
}

export interface JettonBetInfo {
  userId: string;
  username: string;
  avatar: string | null;
  amount: number;
  currency: string;
  cashoutMultiplier: number | null;
  isWinner: boolean;
}

export interface JettonHistoryEntry {
  crashMultiplier: number;
  id: string;
}

export interface JettonRound {
  id: string;
  index: number;
  status: JettonStatus;
  serverSeedHash: string | null;
  startTimeMs: number | null;
  startsInMs: number | null; // remaining ms in WAITING — from server, avoids clock skew
  crashMultiplier: number | null;
  totalBet: number;
  totalsByCurrency: Record<string, number>;
  bets: JettonBetInfo[];
  history?: JettonHistoryEntry[];
}

export interface AutoplayConfig {
  isActive: boolean;
  betAmount: number;
  cashoutMultiplier: number;
  numberOfGames: number;
  gamesPlayed: number;
}

export interface JettonState {
  currentRound: JettonRound;
  history: JettonHistoryEntry[];
  myCashout: { multiplier: number; payout: number } | null;
  waitingEndsAtMs: number | null;
  selectedCurrency: CurrencyCode;
  autoplay: AutoplayConfig;
}

export interface JettonHistoryItem {
  id: string;
  index: number;
  crashMultiplier: number;
  totalBet: number;
  totalsByCurrency: Record<string, number>;
  finishedAt: string | null;
  serverSeedHash: string | null;
}

export interface JettonPaginatedHistory {
  items: JettonHistoryItem[];
  total: number;
  page: number;
  pageSize: number;
  hasMore: boolean;
}

export interface JettonBetDetail {
  userId: string;
  username: string;
  avatar: string | null;
  amount: number;
  currency: string;
  cashoutMultiplier: number | null;
  payout: number | null;
  isWinner: boolean;
}

export interface JettonRoundDetail {
  id: string;
  index: number;
  crashMultiplier: number | null;
  totalBet: number;
  totalsByCurrency: Record<string, number>;
  finishedAt: string | null;
  serverSeed: string | null;
  serverSeedHash: string | null;
  clientSeed: string | null;
  nonce: number | null;
  resultFloat: number | null;
  bets: JettonBetDetail[];
}
